/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import {
  Select,
  Radio,
  Button,
  Input,
  Checkbox,
} from "antd";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import ServiceApi from "../../../services/ServiceApi";
import { changeLang } from "../../../actions/langAction";

class ServiceCheckList extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      title: "SERVICE TYPE",
      job_type: [],
      sub_type: [],
      jobcategory: "",
      form: [
        {
          no: 1,
          description: "",
        },
      ],
      Priority: 1,
      modalstatus: false,
      set_asset: [],
      status_cookie: 0,
      job_cat: [],
      data_translate: [],
      factupdate: false,
      count_colum: 0,

      columns: [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
        },
        {
          title: "Description",
          dataIndex: "description",
          key: "description",
        },
        {
          title: "Check Box",
          dataIndex: "checkbox",
          key: "checkbox",
          align: "center",
        },
        {
          title: "หมายเหตุ",
          key: "remark",
          dataIndex: "remark",
          align: "center",
        },
        {
          title: "Photo",
          dataIndex: "photo",
          key: "",
          align: "center",
        },
        {
          title: "Action",
          dataIndex: "",
          key: "",
          align: "center",
          sorter: () => null,
          render: (item) => (
            <>
              <a
                className="font-thai-sb fs-18 text-underline"
                style={{ color: "#6864FF" }}
                onClick={() => this.onDelete(item)}
              >
                <img
                  style={{
                    float: "center",
                    marginLeft: "-15px",
                  }}
                  src={Api.absoluteUrl("/icon/delete_colum.svg")}
                />
              </a>
            </>
          ),
        },
      ],
      columns_description: [
        {
          title: "No.",
          dataIndex: "no",
          key: "no",
        },
        {
          title: "Description",
          dataIndex: "description",
          key: "description",
        },
        {
          title: "Action",
          dataIndex: "",
          key: "",
        },
      ],
      data_title: [],
      data_description: [],
      // for service checklist
      factUpdate: false,
      customs: {
        select_object_path: null,
      },
      sel_type: null,
      sel_new_type: null,
      sel_sub_cat: null,
      ObjectPart: [],
      serviceType: [],
      newType: [],
      subCategory: [],
      sla_level: [],
      std_hour: "",
      std_day: "",
      std_minute: "",
      sla_id: "",
      sel_sla: null,
      form: {},
    };
  }
  handleCheckListVisible = () => {
    this.props.handleVisible(false);
  };
  handleproblem = async (name, value) => {
    switch (name) {
      case "objectpart":
        this.setState({
          customs: {
            select_object_path: value,
          },
        });
        ServiceApi.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: null,
          service_lv3: null,
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            this.state.form["service_type_level_id"] = value;
            this.setState({
              service_type_level_id: value.substring(0, 2),
              serviceType: response.data.data.result,
              sel_type: null,
              sel_new_type: null,
              sel_sub_cat: null,
              newType: [],
              subCategory: [],
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "servicetype":
        ServiceApi.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: value.substring(2, 4),
          service_lv3: null,
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            this.state.form["service_type_level_id"] = value;
            this.setState({
              service_type_level_id:
                this.state.service_type_level_id + value.substring(2, 4),
              sel_type: value,
              newType: response.data.data.result,
              sel_new_type: null,
              sel_sub_cat: null,
              subCategory: [],
              // sla_level: [],
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "new_type":
        ServiceApi.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: value.substring(2, 4),
          service_lv3: value.substring(4, 6),
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            this.state.form["service_type_level_id"] = value;
            this.setState({
              sel_new_type: value,
              service_type_level_id: value,
              subCategory: response.data.data.result,
              sel_sub_cat: null,
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "sub_category":
        const get_job_sla = await ServiceApi.post("get_job_sla", {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          job_sub_type_id: 0,
          service_type_level_id: value,
        });

        this.setState({
          service_type_level_id: value,
          sla_level:
            get_job_sla.data.data.result.length === 0
              ? []
              : get_job_sla.data.data.result,
          sel_sub_cat: value,
          // std_hour: "",
          // std_day: "",
          // std_minute: "",
          // sla_id: "",
          sel_sla:
            get_job_sla.data.data.result.length === 0
              ? "0"
              : get_job_sla.data.data.result[0].job_sla_id,
          std_hour:
            get_job_sla.data.data.result.length === 0
              ? "0"
              : get_job_sla.data.data.result[0].sla_time_hour,
          std_day:
            get_job_sla.data.data.result.length === 0
              ? "0"
              : get_job_sla.data.data.result[0].sla_time_day,
          std_minute:
            get_job_sla.data.data.result.length === 0
              ? "0"
              : get_job_sla.data.data.result[0].sla_time_day,
          sla_id:
            get_job_sla.data.data.result.length === 0
              ? "0"
              : get_job_sla.data.data.result[0].job_sla_id,
        });
        break;
      case "sla":
        this.setState({
          std_hour: "",
          std_day: "",
          std_minute: "",
          sla_id: "",
        });

        this.setState({
          sel_sla: value,
          std_hour: this.state.sla_level[0].sla_time_hour,
          std_day: this.state.sla_level[0].sla_time_day,
          std_minute: this.state.sla_level[0].sla_time_day,
          sla_id: value,
        });
        break;
      default:
        return null;
    }
  };
  async componentDidMount() {
    document.title = "MaxiOperation - " + this.state.title;

    const GetJobCategoty = await Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
      operator_id: Cookies.get("operator_id"),
    });
    const data_language = await Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    });
    // console.log(this.state.form)
    this.setState({
      data_title: [
        {
          no: this.state.data_title.length + 1,
          description: (
            <Input
              placeholder="Description"
              id={this.state.data_title.length}
              onChange={(value) => this.handleDataTitle(value)}
            />
          ),
          checkbox: <Checkbox />,
          remark: <Checkbox />,
          photo: <Checkbox />,
        },
      ],

      data_description: [
        {
          no: this.state.data_title.length + 1,
          description: "Test",
        },
      ],
      job_cat: GetJobCategoty.data.data.result_data,
      data_translate: JSON.parse(
        data_language.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
      ),
      factupdate: true,
    });
    ServiceApi.post("get_service_type_ma_list_each_level", {
      company_id: Cookies.get("companyid"),
      job_category_id: this.state.jobcategory,
      job_type_id: this.state.selected_jobtype,
      service_lv1: null,
      service_lv2: null,
      service_lv3: null,
      service_lv4: null,
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        // this.state.form["service_type_level_id"] = value;
        console.log("respond from data", response);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async btnjobDetail(n) {
    Api.post("get_job_type", {
      pk_id: null,
      fk_id: n,
      is_active: "1",
      effective: "1",
      sql_where: null,
      company_id: Cookies.get("companyid"),
    })
      .then((response) => {
        this.setState({
          selected_jobtype: null,
          selected_subtype: null,
          sub_type: [],
          jobcategory: n,
          job_type: response.data.data,
        });
        setTimeout(() => {
          this.Setdata_jobtype(this.state.data_local.job_type_id);
        }, 100);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async handleSelectChange(name, value) {
    if (name === "ma_period_id") {
      const found = this.state.get_preiod.find(
        (element) => element.ma_period_id === value
      );

      var form = this.state.form;
      form[name] = value;

      this.setState({
        period_start: moment(found.ma_time_start).format("HH:MM"),
        period_end: moment(found.ma_time_end).format("HH:MM"),
      });
      this.setState(form);
    } else {
      var form = this.state.form;
      form[name] = value;
      this.setState(form);
    }
  }
  handleSubmit = async () => {};
  setcolum_title = () => {
    console.log(this.state.data_title.length);
    console.log(this.state.data_title);
    this.setState({
      data_title: [
        ...this.state.data_title,
        {
          no: this.state.data_title.length + 1,
          description: (
            <Input
              placeholder="Description"
              id={this.state.data_title.length}
              onChange={(value) => this.handleDataTitle(value)}
            />
          ),
          checkbox: <Checkbox />,
          remark: <Checkbox />,
          photo: <Checkbox />,
        },
      ],
      form: [
        ...this.state.form,
        {
          no: "",
          description: "",
        },
      ],
      data_description: [
        ...this.state.data_description,
        {
          no: this.state.data_title.length + 1,
          description: "",
        },
      ],
    });
    console.log(this.state.data_title);
  };
  onDelete = async (key) => {
    // console.log(key.no);
    // console.log(this.state.data_title);
    // const dataSource_title = [...this.state.data_title];
    // console.log(this.state.data_title);
    // const setdata_title = await this.state.data_title.filter((item) => item.no !== key.no);
    // const dataSource_des = [...this.state.data_description];
    // const setdata_des = dataSource_des.filter((item) => item.no !== key.no);

    // console.log(setdata_title);
    // for (let i = 0; i < setdata_title.length; i++) {
    //   setdata_title[i]["no"] = i + 1;
    // }
    // for (let i = 0; i < setdata_des.length; i++) {
    //   setdata_des[i]["no"] = i + 1;
    // }, data_description: setdata_des

    // console.log(setdata_title);
    const dataSource = [...this.state.data_title];
    console.log(dataSource);
    const setdata_title = await dataSource.filter((item) => item.no !== key.no);
    console.log(key.no);
    console.log(setdata_title);
    this.setState({
      data_title: setdata_title,
    });
    // this.setState({ data_title: setdata_title });
  };
  handleDataTitle = (data) => {
    console.log(data.target);
    console.log(data.target.id);
    this.state.form[data.target.id]["no"] = parseInt(data.target.id) + 1;
    this.state.form[data.target.id]["description"] = data.target.value;

    console.log(this.state.form);
    // console.log(this.state.data_title);
    // console.log(data.target.value);
    // console.log(key - 1);
    // // data_description[0]
    // this.state.data_description[key - 1]["description"] = data.target.value;
    // console.log(this.state.data_description);
    // this.setState({
    //   data_description: this.state.data_description,
    // });
  };
  render() {
    const { loading, title, form } = this.state;
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
    const job_cat_btn = this.state.job_cat.map((job_cat, index) => {
      let thismr = "";
      if ((index + 1) % 5 == 0 && index != 0) {
        thismr = "mr-2 ";
      }
      return (
        <div
          key={index + 5478}
          className={"col-2 " + thismr + "p0"}
          style={{ marginBottom: "10px" }}
        >
          <button
            type="button"
            className={
              this.state.jobcategory == job_cat.job_category_id
                ? "btndetailshow"
                : "btndetailhide"
            }
            // disabled={this.state.fack_check === 1 ? true : false}
            onClick={this.btnjobDetail.bind(this, job_cat.job_category_id)}
          >
            <img
              style={{
                float: "right",
                marginRight: "10px",
              }}
              src={Api.absoluteUrl(
                this.state.jobcategory == job_cat.job_category_id
                  ? "/icon/job_show.svg"
                  : "/icon/job_dis.svg"
              )}
            />
            <br className="mt-2" />
            <img
              style={{
                float: "center",
                marginLeft: "-15px",
              }}
              src={Api.absoluteUrl("/icon/" + job_cat.icon_name)}
            />
            <span
              style={{
                marginLeft: "-20px",
                fontSize: "12px",
                color: "#0500A3",
              }}
            >
              <br className="mt-2" />
              {job_cat.job_category_name}
            </span>
          </button>
        </div>
      );
    });
    return (
      <>
        {this.state.factupdate ? (
          <>
            <div
              className="container mb-2"
              style={{ maxWidth: "95%", marginTop: "0%" }}
            >
              <div className="row">
                <div
                  className="col-12 mt-2 "
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                >
                  <span style={{ color: "#0500A3", fontSize: "16px" }}>
                    <img
                      src={Api.absoluteUrl("/icon/pust.svg")}
                      width="14"
                      className="mr-2"
                    />
                    <b className="mr-2"> {this.state.title} </b>
                    {/* go back button */}
                    <Button
                      type="link"
                      onClick={this.handleCheckListVisible}
                      className="font-thai-r fs-22 c-blue"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <span
                        style={{ marginLeft: "5px", marginBottom: "20px" }}
                        className="fs-22"
                      >
                        Back
                      </span>
                    </Button>
                  </span>
                  <div className="card mt-2" style={{ width: "95%" }}>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="col-3">
                          <label className="labeaddjob">
                            {"Service Type Name"}
                          </label>{" "}
                          <br />
                          <Input placeholder="Name" />
                        </div>
                        <div className="col-3">
                          <label className="labeaddjob">{"Status"}</label>
                          <br />
                          <Radio.Group
                            onChange={this.onChange}
                            value={this.state.value}
                          >
                            <Radio value={1}>Active</Radio>
                            <Radio value={2}>Inactive</Radio>
                          </Radio.Group>
                        </div>
                        <div className="col-3"></div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-3"></div>
                        <div className="col-3">
                          {/* Operator */}
                          <label className="labeaddjob">
                            {"Operators"}
                          </label>{" "}
                          <br />
                          <select
                            style={{ height: "30px", width: "100%" }}
                            // className="dropdrowtype"
                            onChange={(e) =>
                              this.Setdata_jobtype(e.target.value)
                            }
                            defaultValue={this.state.selected_jobtype || ""}
                            value={this.state.selected_jobtype}
                          >
                            <option value="" disabled>
                              Please select
                            </option>
                            {this.state.job_type.map((item, index) => (
                              <option
                                value={item.job_type_id}
                                defaultValue={this.state.selected_jobtype}
                              >
                                {item.job_type_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-3">
                          <label className="labeaddjob">{"Create By"}</label>
                          <br />
                          <Input placeholder="Name" />
                        </div>
                        <div className="col-3"></div>
                      </div>
                    </div>
                  </div>
                  <div className="card mt-2" style={{ width: "95%" }}>
                    <div className="card-body">
                      <div className="mt-2 divshow">
                        <div className="row">
                          {/* <div className="col-2"> </div> */}
                          <div className="col-12">
                            <img
                              style={{
                                float: "left",
                                marginTop: "7px",
                                marginRight: "10px",
                              }}
                              src={Api.absoluteUrl("/icon/setting.svg")}
                            />
                            <span className="jobdetail">
                              {" "}
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["job_detail"]
                              }
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-2"> </div>
                          <div className="col-10">
                            <div className="row">
                              <div className="col-12">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                      Cookies.get("locale")
                                    ]["job_category"]
                                  }{" "}
                                  <b style={{ color: "#DF4547" }}>*</b>
                                </label>
                                <br />
                                <div className="row">{job_cat_btn}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-5">
                          <div className="col-2"> </div>
                          <div className="col-10">
                            <div className="row">
                              <div className="col-6">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                      Cookies.get("locale")
                                    ]["job_type"]
                                  }{" "}
                                  <b style={{ color: "#DF4547" }}> * </b>{" "}
                                </label>
                                <br />
                                <select
                                  style={{ height: "30px", width: "80%" }}
                                  // className="dropdrowtype"
                                  onChange={(e) =>
                                    this.Setdata_jobtype(e.target.value)
                                  }
                                  defaultValue={
                                    this.state.selected_jobtype || ""
                                  }
                                  value={this.state.selected_jobtype}
                                >
                                  <option value="" disabled>
                                    Please select
                                  </option>
                                  {this.state.job_type.map((item, index) => (
                                    <option
                                      value={item.job_type_id}
                                      defaultValue={this.state.selected_jobtype}
                                    >
                                      {item.job_type_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-6">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                      Cookies.get("locale")
                                    ]["job_sub_type"]
                                  }{" "}
                                </label>
                                <br />
                                <select
                                  style={{ height: "30px", width: "80%" }}
                                  // className="dropdrowtype"
                                  onChange={(e) =>
                                    this.setState({
                                      selected_subtype: e.target.value || null,
                                    })
                                  }
                                  defaultValue={this.state.selected_subtype}
                                  value={this.state.selected_subtype}
                                >
                                  <option value="" disabled>
                                    Please select
                                  </option>
                                  {this.state.sub_type.map((item, index) => (
                                    <option
                                      value={item.job_sub_type_id}
                                      defaultValue={this.state.selected_subtype}
                                    >
                                      {item.job_type_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card mt-2" style={{ width: "95%" }}>
                    <div className="card-body">
                      <div className="mt-2 divshow">
                        <div className="row">
                          {/* <div className="col-2"> </div> */}
                          <div className="col-6">
                            <img
                              style={{
                                float: "left",
                                marginTop: "7px",
                                marginRight: "10px",
                              }}
                              src={Api.absoluteUrl("/icon/setting.svg")}
                            />
                            {/* Job detail */}
                            <span className="jobdetail">{"Job Detail"}</span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-2"></div>
                          <div className="col-8">
                            <div className="row">
                              <div className="col-6">
                                {" "}
                                {this.state.factupdate ? (
                                  <label
                                    className="labeaddjob font-thai-r"
                                    style={{ fontSize: "18px" }}
                                  >
                                    Object Part{" "}
                                    <b style={{ color: "#DF4547" }}>*</b>
                                  </label>
                                ) : null}
                                <Select
                                  style={{ width: "100%" }}
                                  className="dropdrowtype"
                                  onChange={(value) =>
                                    this.handleproblem("objectpart", value)
                                  }
                                  value={
                                    this.state.customs.select_object_path || ""
                                  }
                                >
                                  <Select.Option value="" disabled>
                                    Please select
                                  </Select.Option>
                                  {this.state.ObjectPart.map((item, index) => (
                                    <Select.Option
                                      key={index}
                                      value={item.service_type_level_id || ""}
                                    >
                                      {item.service_desc}
                                    </Select.Option>
                                  ))}
                                </Select>
                                {this.state.valid_obj_part === false &&
                                this.state.valid === true ? (
                                  <b
                                    className="labeaddjob mt-4"
                                    style={{ color: "#DF4547" }}
                                  >
                                    {" "}
                                    กรุณาเลือก Object Part{" "}
                                  </b>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="col-6">
                                {" "}
                                {this.state.factupdate ? (
                                  <div>
                                    <label
                                      className="labeaddjob font-thai-r"
                                      style={{ fontSize: "18px" }}
                                    >
                                      Service Type{" "}
                                      <b style={{ color: "#DF4547" }}>*</b>
                                    </label>
                                  </div>
                                ) : null}
                                <Select
                                  style={{ width: "100%" }}
                                  defaultValue=""
                                  className="dropdrowtype"
                                  onChange={(value) =>
                                    this.handleproblem("servicetype", value)
                                  }
                                  value={this.state.sel_type || ""}
                                >
                                  <Select.Option value="" disabled>
                                    Please select
                                  </Select.Option>
                                  {this.state.serviceType.map((item, index) => (
                                    <Select.Option
                                      key={index}
                                      value={item.service_type_level_id || ""}
                                    >
                                      {item.service_desc}
                                    </Select.Option>
                                  ))}
                                </Select>
                                {this.state.valid_service_type === false &&
                                this.state.valid === true ? (
                                  <b
                                    className="labeaddjob mt-4"
                                    style={{ color: "#DF4547" }}
                                  >
                                    {" "}
                                    กรุณาเลือก Service Type{" "}
                                  </b>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* category and subcategory type */}
                        <div className="row mt-3 ">
                          <div className="col-2"> </div>
                          <div className="col-8">
                            <div className="row">
                              <div className="col-6">
                                {" "}
                                {this.state.factupdate ? (
                                  <label
                                    className="labeaddjob font-thai-r"
                                    style={{ fontSize: "18px" }}
                                  >
                                    Category Type{" "}
                                    <b style={{ color: "#DF4547" }}>*</b>
                                  </label>
                                ) : null}
                                <Select
                                  style={{ width: "100%" }}
                                  defaultValue=""
                                  className="dropdrowtype"
                                  value={this.state.sel_new_type || ""}
                                  onChange={(value) =>
                                    this.handleproblem("new_type", value)
                                  }
                                >
                                  <Select.Option value="" disabled>
                                    Please select
                                  </Select.Option>
                                  {this.state.newType.map((item, index) => (
                                    <Select.Option
                                      key={index}
                                      value={item.service_type_level_id || ""}
                                    >
                                      {item.service_desc}
                                    </Select.Option>
                                  ))}
                                </Select>
                                {this.state.valid_new_type === false &&
                                this.state.valid === true ? (
                                  <b
                                    className="labeaddjob mt-4"
                                    style={{ color: "#DF4547" }}
                                  >
                                    {" "}
                                    กรุณาเลือก Service Type{" "}
                                  </b>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="col-6">
                                {" "}
                                {this.state.factupdate ? (
                                  <label
                                    className="labeaddjob font-thai-r"
                                    style={{ fontSize: "18px" }}
                                  >
                                    Sub Category{" "}
                                    <b style={{ color: "#DF4547" }}>*</b>
                                  </label>
                                ) : null}
                                <Select
                                  style={{ width: "100%" }}
                                  defaultValue=""
                                  value={form.sub_category}
                                  className="dropdrowtype"
                                  value={this.state.sel_sub_cat || ""}
                                  onChange={(value) =>
                                    this.handleproblem("sub_category", value)
                                  }
                                >
                                  <Select.Option value="" disabled>
                                    Please select
                                  </Select.Option>
                                  {this.state.subCategory.map((item, index) => (
                                    <Select.Option
                                      key={index}
                                      value={item.service_type_level_id || ""}
                                    >
                                      {item.service_desc}
                                    </Select.Option>
                                  ))}
                                </Select>
                                {this.state.valid_sub_cat === false &&
                                this.state.valid === true ? (
                                  <b
                                    className="labeaddjob mt-4"
                                    style={{ color: "#DF4547" }}
                                  >
                                    {" "}
                                    กรุณาเลือก Sub Category{" "}
                                  </b>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* SLA level */}
                        <div className="row mt-3 ">
                          <div className="col-2"> </div>
                          <div className="col-8">
                            <div className="row">
                              <div className="col-3">
                                {" "}
                                {this.state.factupdate ? (
                                  <label
                                    className="labeaddjob font-thai-r"
                                    style={{ fontSize: "18px" }}
                                  >
                                    SLA Level
                                  </label>
                                ) : null}
                                <Select
                                  style={{ width: "100%" }}
                                  defaultValue=""
                                  className="dropdrowtype"
                                  value={this.state.sel_sla || ""}
                                  onChange={(value) =>
                                    this.handleproblem("sla", value)
                                  }
                                >
                                  <Select.Option value="0" disabled>
                                    Please select
                                  </Select.Option>
                                  {this.state.sla_level.map((item, index) => (
                                    <Select.Option
                                      key={index}
                                      value={item.job_sla_id}
                                    >
                                      {item.sla_name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </div>
                              <div className="col-3">
                                {" "}
                                {this.state.factupdate ? (
                                  <label
                                    className="labeaddjob font-thai-r"
                                    style={{ fontSize: "18px" }}
                                  >
                                    Standard Day
                                  </label>
                                ) : null}
                                <input
                                  disabled
                                  type="text"
                                  className="inputfile"
                                  style={{ width: "100%", padding: "5px" }}
                                  name="inform_name"
                                  value={this.state.std_day}
                                ></input>
                              </div>
                              <div className="col-3">
                                {" "}
                                {this.state.factupdate ? (
                                  <label
                                    className="labeaddjob font-thai-r"
                                    style={{ fontSize: "18px" }}
                                  >
                                    Standard Hour
                                  </label>
                                ) : null}
                                <input
                                  disabled
                                  type="text"
                                  className="inputfile"
                                  style={{ width: "100%", padding: "5px" }}
                                  name="inform_name"
                                  value={this.state.std_hour}
                                ></input>
                              </div>
                              <div className="col-3">
                                {" "}
                                {this.state.factupdate ? (
                                  <label
                                    className="labeaddjob font-thai-r"
                                    style={{ fontSize: "18px" }}
                                  >
                                    Standard Minute
                                  </label>
                                ) : null}
                                <input
                                  disabled
                                  type="text"
                                  className="inputfile"
                                  style={{ width: "100%", padding: "5px" }}
                                  name="inform_name"
                                  value={this.state.minute}
                                ></input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-12 mt-2 "
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    textAlign: "center",
                  }}
                >
                  <button
                    type="button"
                    className="btnCancel "
                    // onClick={this.handleSubmit}
                  >
                    <span style={{ fontSize: "16px" }}>Cancel</span>
                  </button>
                  <button
                    type="button"
                    className="btnSubmit ml-2"
                    // onClick={this.handleSubmit}
                  >
                    <span style={{ fontSize: "16px" }}>Submit</span>
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(ServiceCheckList);
